export default __webpack_public_path__ + "static/media/heavy_rain.0f3d0851.svg";